import {
	fetchIdBack,
	fetchIdFront,
	fetchPassport,
	resetLoader,
	selectDocuments,
	submitDocument,
	addScannedDocumentNumber,
} from '../../redux/slices/documentSlice';
import {
	fetchProfile,
	selectProfile,
	setProfileID,
	updateProfileID,
} from '../../redux/slices/profileSlice';
import {
	fetchReservationProfiles,
	selectSession,
	setEmail,
	setPhone,
} from '../../redux/slices/sessionSlice';
import React, { useCallback, useEffect } from 'react';
import { selectStage, skipStage } from '../../redux/slices/stageSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hook';

import { DarkButton } from '../../components/dark-button';
import DocumentUploadTabs from '../../components/document-upload-tabs';
import { getCapitalCase } from '../../utils';
import ImageUploadBox from '../../components/image-upload-box';
import Loading from '../../components/loading';
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import useState from 'react-usestateref';
import useStateRef from 'react-usestateref';
import { useTranslation } from 'react-i18next';

export default function DocuSubmissionHome({
	callback,
	skipDocuSubmission,
	numberOfProfilesToCheckIn,
	currentProfileIndex,
	adultCount,
	childCount,
}: {
	callback: any;
	skipDocuSubmission: any;
	numberOfProfilesToCheckIn: any;
	currentProfileIndex: any;
	adultCount: any;
	childCount: any;
}) {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [__, setSelectedButton, selectedButtonRef] = useState(0);
	const [____, setButtonLoading, buttonLoadingRef] = useStateRef(false);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { token, reservation, propertyInfo, settings } =
		useAppSelector(selectSession);
	const { passport, idFront, idBack, supportDocs, scannedDocumentNumbers } =
		useAppSelector(selectDocuments);
	const { stages, stage } = useAppSelector(selectStage);

	let supportDocsDisplay = '';
	useEffect(() => {
		supportDocsDisplay = 'Supported document: ';
	}, [supportDocs]);

	const { currentProfile: profile } = useAppSelector(selectProfile);
	const [___, setShowSkipModal, showSkipModalRef] = useState(false);
	// const [_____, setFinishShowLoader, ShowFinishLoader] = useState(false);
	const [______, setIsChildScan, isChildScan] = useState(false);

	const [ShowFinishLoader, setFinishShowLoader] = useState(false);
	/* eslint-disable no-debugger */
	// debugger;
	/* eslint-enable no-debugger */
	// console.log(
	// 	'numberOfProfilesToCheckIn==>' +
	// 		numberOfProfilesToCheckIn +
	// 		'currentProfileIndex=' +
	// 		currentProfileIndex +
	// 		'adultCount' +
	// 		adultCount +
	// 		',' +
	// 		childCount
	// );
	const childAgeLimit = settings?.find(
		(setting: any) => setting.parameterName === 'ChildAgeLimit'
	)?.parameterValue;

	const adultAgeLimit = settings?.find(
		(setting: any) => setting.parameterName === 'AdultAgeLimit'
	)?.parameterValue;

	if (profile !== null && profile !== undefined && currentProfileIndex === 0) {
		dispatch(setEmail(profile['email']));
		dispatch(setPhone(profile['phoneNo_Res']));
	}
	useEffect(() => {
		if (childCount > 0 && currentProfileIndex > adultCount) {
			setIsChildScan(true);
		}
	}, []);

	useEffect(() => {
		if (ShowFinishLoader) {
			const timer = setTimeout(() => setFinishShowLoader(false), 100);
			return () => clearTimeout(timer);
		}
	}, [ShowFinishLoader]);

	const skipAccompanyDocument =
		settings?.find(
			(setting: any) =>
				setting.parameterName === 'SkipAccompanyDocument' &&
				setting.parameterValue === 'true'
		) ?? false;

	const forcedSkipAccompanyDocument =
		settings?.find(
			(setting: any) =>
				setting.parameterName === 'ForcedSkipAccompanyDocument' &&
				setting.parameterValue === 'true'
		) ?? false;

	const skipChildDocument =
		settings?.find(
			(setting: any) =>
				setting.parameterName === 'SkipChildDocument' &&
				setting.parameterValue === 'true'
		) ?? false;

	const skipPrimaryDocument =
		settings?.find(
			(setting: any) =>
				setting.parameterName === 'SkipPrimaryDocument' &&
				setting.parameterValue === 'true'
		) ?? false;

	// settings?.map((p: any) => {
	// 	console.log(
	// 		p.parameterName + ',' + p.parameterValue + '###SkipAccompanyDocument '
	// 	);
	// });
	console.log(
		skipAccompanyDocument +
			'###SkipAccompanyDocument ' +
			',' +
			currentProfileIndex
	);

	console.log('forcedSkipAccompanyDocument ', forcedSkipAccompanyDocument);
	console.log('IsAccompany ', !profile?.isPrimary);

	if (forcedSkipAccompanyDocument && !profile?.isPrimary) {
		skipDocuSubmission();
	}

	const submitFiles = async () => {
		if (
			(selectedButtonRef.current == 1 &&
				!t('DocuScanPagePrimaryTab').toLowerCase().startsWith('p')) ||
			(selectedButtonRef.current != 1 &&
				t('DocuScanPagePrimaryTab').toLowerCase().startsWith('p'))
		) {
			if (passport !== null) {
				setFinishShowLoader(false);
				/* eslint-disable no-debugger */
				try {
					/* eslint-disable no-debugger */
					// await dispatch(
					// 	submitDocument({
					// 		token: token,
					// 		profileID: profile?.profileID,
					// 		pmsConfirmationNo: reservation?.PmsConfirmationNo,
					// 		docufront: passport,
					// 		docuback: '',
					// 		isPassport: true,
					// 		propertyCode: propertyInfo?.propertyCode ?? '', //added new
					// 		lastName: profile?.lastName,
					// 		currentProfileIndex: currentProfileIndex,
					// 	})
					// );

					dispatch(
						submitDocument({
							token: token,
							profileID: profile?.profileID,
							pmsConfirmationNo: reservation?.PmsConfirmationNo,
							docufront: passport,
							docuback: '',
							isPassport: true,
							propertyCode: propertyInfo?.propertyCode ?? '', //added new
							lastName: profile?.lastName,
							fullName: profile?.firstName + ' ' + profile?.lastName,
							currentProfileIndex: currentProfileIndex,
							isChild: isChildScan.current,
							childAgeLimit: childAgeLimit,
							adultAgeLimit: adultAgeLimit,
							scannedDocumentNumbers: scannedDocumentNumbers,
						})
					)
						.unwrap()
						.then((result) => {
							dispatch(addScannedDocumentNumber(result?.documentNumber));
							if (
								result?.profileID !== null &&
								result?.profileID !== undefined
							) {
								if (profile === null || profile === undefined) {
									dispatch(
										fetchReservationProfiles({
											token,
											confirmationNo: reservation?.PmsConfirmationNo,
										})
									)
										.unwrap()
										.then((profileList) => {
											dispatch(
												fetchProfile({
													profiles: profileList,
													profileID: result?.profileID,
												})
											);
										});
								}
							}
							setFinishShowLoader(true);
						})
						.catch((error) => {
							setFinishShowLoader(true);
							// Handle any error
							console.error('Error submitting document:', error);
							Swal.fire({
								icon: 'error',
								title: 'Oops...',
								text: error.error,
							});
							//dispatch(setDocumentFinished(true));
						});

					// Check if the properties are defined before accessing them
					//const lastName = response?.documentMetaData?.surname;
				} catch (error) {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'An error occurred. Please try again later or please proceed to front desk for assistance.',
					});
				}
			}
			//setShowLoader(true);
			console.log('came set loader 1 ' + buttonLoadingRef.current);
		} else {
			if (idBack !== null && idFront !== null) {
				setFinishShowLoader(false);
				try {
					dispatch(
						submitDocument({
							token: token,
							profileID: profile?.profileID,
							pmsConfirmationNo: reservation?.PmsConfirmationNo,
							docufront: idFront,
							docuback: idBack,
							isPassport: false,
							propertyCode: propertyInfo?.propertyCode ?? '', //added new
							lastName: profile?.lastName, //added new
							fullName: profile?.firstName + ' ' + profile?.lastName,
							currentProfileIndex: currentProfileIndex,
							isChild: isChildScan.current,
							childAgeLimit: childAgeLimit,
							adultAgeLimit: adultAgeLimit,
							scannedDocumentNumbers: scannedDocumentNumbers,
						})
					)
						.unwrap()
						.then((result) => {
							dispatch(addScannedDocumentNumber(result?.documentNumber));
							if (
								result?.profileID !== null &&
								result?.profileID !== undefined
							) {
								if (profile === null || profile === undefined) {
									dispatch(
										fetchReservationProfiles({
											token,
											confirmationNo: reservation?.PmsConfirmationNo,
										})
									)
										.unwrap()
										.then((profileList) => {
											dispatch(
												fetchProfile({
													profiles: profileList,
													profileID: result?.profileID,
												})
											);
										});
								}
							}

							setFinishShowLoader(true);
						})
						.catch((error) => {
							setFinishShowLoader(true);
						});
				} catch (error) {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'An error occurred. Please try again later or please proceed to front desk for assistance.',
					});
					setFinishShowLoader(true);
				}
				console.log('came set loader 2');
			} else {
				setFinishShowLoader(false);
				Swal.fire({
					text: t('DocuScanIDWarningMessage'),
					icon: 'info',
				}).then(function () {
					console.log('ok');
					setFinishShowLoader(true);
				});
			}
		}

		callback();
	};

	// if (currentProfileIndex === 1) {
	// 	if (profile === undefined) {
	// 		Swal.fire({
	// 			//title: 'No profile found',
	// 			text: 'Please proceed to front desk for assistance',
	// 			icon: 'error',
	// 		}).then(function () {
	// 			window.location.reload();
	// 		});
	// 	}
	// }

	// return profile === null && profile !== undefined ? (
	// 	<Loading />
	// ) :

	function getOrdinalSuffix(n: number): string {
		const s = ['th', 'st', 'nd', 'rd'];
		const v = n % 100; // Get the last two digits
		return n + (s[(v - 20) % 10] || s[v] || s[0]);
	}
	function documentSkipCancel() {
		setShowSkipModal(false);
		setButtonLoading(false);
		setFinishShowLoader(true);
		console.log('######################', buttonLoadingRef);
	}

	return (
		<div
			className="pt-4 mx-auto"
			style={{
				paddingBottom: '110px',
				overflow: 'auto',
				height: 'calc(100vh - 80px)',
			}}>
			<div
				className="d-flex flex-column gap-4 mx-auto"
				style={{
					maxWidth: '1200px',
				}}>
				<div className="d-flex flex-column gap-2 px-3 mt-2 text-lg-center">
					<div>
						{/* {propertyInfo?.propertyCode == 'YAM' ||
						process.env.REACT_APP_THEME == 'YAM' ? ( */}
						<div className="theme-docu-header">
							<p className="theme-active-paragraph mb-0">To get started,</p>
							<p className="theme-bold-paragraph">{t('DocuScanPageMessage')}</p>
						</div>

						<div className="theme-docu-header-name">
							<h2
								className="mb-0"
								style={{
									fontSize: '1.5rem',
								}}>
								{childCount > 0 && currentProfileIndex > adultCount
									? getCapitalCase(
											profile?.firstName || profile?.lastName
												? profile?.firstName + ' ' + profile?.lastName + ','
												: 'Child: ' + (currentProfileIndex - adultCount)
									  )
									: getCapitalCase(
											profile?.firstName || profile?.lastName
												? profile?.firstName + ' ' + profile?.lastName + ','
												: getOrdinalSuffix(currentProfileIndex - 1) +
														' Accompany user'
									  )}
							</h2>
							<p className="mb-0 mt-2 lh-sm">{t('DocuScanPageMessage')}</p>
						</div>
					</div>

					<>
						{/* {propertyInfo?.propertyCode == 'YAM' ||
						process.env.REACT_APP_THEME == 'YAM' ? ( */}
						{t('DocuScanPageSupportedDocs').trim() === '' ? (
							<></>
						) : (
							<div
								className="card px-4 py-2"
								style={{
									fontSize: '0.9rem',
								}}>
								{supportDocs && Array.isArray(supportDocs) ? (
									<div className="row theme-support-doc">
										<div
											className=" col-10 col-xs-11 col-sm-11 col-md-11 col-lg-12"
											style={{
												alignContent: 'center',
												padding: '2px 0px 2px 0px',
											}}>
											<img
												className="align-middle me-3"
												src={process.env.PUBLIC_URL + '/id_icon.svg'}
												style={{ height: '2.1em' }}></img>
											<span
												style={{ fontSize: '0.9em', verticalAlign: 'center' }}>
												{t('DocuScanPageSupportedDocs')}
												{supportDocs.map((item, index) => {
													return index == supportDocs.length - 1 && index > 0
														? ' and ' + item?.Description
														: ' ' +
																item?.Description +
																(supportDocs.length > 2 ? ',' : '');
												})}
											</span>
										</div>
									</div>
								) : (
									<>
										<span>{t('DocuScanPageDefaultSupportedDocs')}</span>
									</>
								)}
							</div>
						)}

						{/* ) : (
							<div
								className="text-muted lh-sm mx-lg-auto"
								style={{
									fontSize: '0.9rem',
									textAlign: 'left',
									marginTop: '10px',
								}}>
								<strong style={{ marginTop: '10px', marginBottom: '10px' }}>
									Supported documents:
								</strong>
								<ul>
									{supportDocs && Array.isArray(supportDocs) ? (
										<>
											{supportDocs.map((item, index) => (
												<li key={index} style={{ marginBottom: '10px' }}>
													{item?.Description}
												</li>
											))}
										</>
									) : (
										<>
											<li style={{ marginBottom: '10px', marginTop: '10px' }}>
												All International Passports
											</li>
											<li style={{ marginBottom: '10px' }}>
												GCC ID Card (Front & Back)
											</li>
										</>
									)}
								</ul>
							</div>
						)} */}
					</>
				</div>

				{!t('DocuScanPagePrimaryTab').toLowerCase().startsWith('p') ? (
					<>
						<DocumentUploadTabs
							setSelectedButton={setSelectedButton}
							selectedButtonRef={selectedButtonRef}></DocumentUploadTabs>
						<div className="row justify-content-sm-center px-4">
							{selectedButtonRef?.current != 0 ? (
								<div className="col-lg-6">
									<ImageUploadBox
										type={t('DocuScanPageUploadFront')}
										file={'passport'}
										fetch={fetchPassport}></ImageUploadBox>
								</div>
							) : (
								<div className="col-12">
									<div className="row">
										<div className="col-sm-12 col-lg-6">
											<ImageUploadBox
												type={t('DocuScanPageUploadFront')}
												file={'idFront'}
												fetch={fetchIdFront}></ImageUploadBox>
										</div>
										<div className="col-sm-12 col-lg-6">
											<ImageUploadBox
												type={t('DocuScanPageUploadBack')}
												file={'idBack'}
												fetch={fetchIdBack}></ImageUploadBox>
										</div>
									</div>
								</div>
							)}
						</div>
					</>
				) : (
					<>
						<DocumentUploadTabs
							setSelectedButton={setSelectedButton}
							selectedButtonRef={selectedButtonRef}></DocumentUploadTabs>
						<div className="row justify-content-sm-center px-4">
							{selectedButtonRef?.current == 0 ? (
								<div className="col-lg-6">
									<ImageUploadBox
										type={t('DocuScanPageUploadFront')}
										file={'passport'}
										fetch={fetchPassport}></ImageUploadBox>
								</div>
							) : (
								<div className="col-12">
									<div className="row">
										<div className="col-sm-12 col-lg-6">
											<ImageUploadBox
												type={t('DocuScanPageUploadFront')}
												file={'idFront'}
												fetch={fetchIdFront}></ImageUploadBox>
										</div>
										<div className="col-sm-12 col-lg-6">
											<ImageUploadBox
												type={t('DocuScanPageUploadBack')}
												file={'idBack'}
												fetch={fetchIdBack}></ImageUploadBox>
										</div>
									</div>
								</div>
							)}
						</div>
					</>
				)}
			</div>

			<div
				className="fixed-bottom d-flex flex-row justify-content-center button-group pb-4 px-2 border-top gap-4 theme-footer"
				style={{
					backgroundColor: 'white',
					borderColor: 'gray',
				}}>
				{currentProfileIndex > 1 && skipAccompanyDocument && (
					<>
						<DarkButton
							text={t('DocuScanButtonSkip')}
							hideArrow
							onClick={() => setShowSkipModal(true)}
							override
						/>
					</>
				)}
				{currentProfileIndex > 1 && skipChildDocument && (
					<>
						<DarkButton
							text={t('DocuScanButtonSkip')}
							hideArrow
							onClick={() => setShowSkipModal(true)}
							override
						/>
					</>
				)}
				{currentProfileIndex === 1 && skipPrimaryDocument && (
					<>
						<DarkButton
							text={t('DocuScanButtonSkip')}
							hideArrow
							onClick={() => {
								setShowSkipModal(true);
								setButtonLoading(false);
							}}
							// loader={buttonLoadingRef.current}
							override={ShowFinishLoader}
						/>
					</>
				)}

				<DarkButton
					text={t('DocuScanButtonNext')}
					onClick={submitFiles}
					filled
					disabled={!passport ? !idBack && !idFront : false}
					loader={buttonLoadingRef.current}
					//override={buttonLoadingRef.current}
					override={ShowFinishLoader}
					// disabled={!passport ? !idBack && !idFront : false}
					// loader={loader ? true : false}
					//override={!passport ? !idBack && !idFront : false}
				/>
			</div>
			<Modal
				centered
				backdrop={true}
				show={showSkipModalRef.current}
				onHide={() => setShowSkipModal(false)}
				contentClassName="skip-modal-content">
				<Modal.Body>
					<p
						className="p-2 text-center m-0 lh-sm"
						style={{ fontSize: '0.9rem' }}>
						Your ID will be required to be presented upon arrival at the hotel.
					</p>
				</Modal.Body>
				<Modal.Footer
					className="p-0"
					style={{
						borderTop: '2px solid #c0c5c5',
					}}>
					<div className="d-flex flex-row justify-content-center w-100 m-0 fw-bold">
						<button
							id="btn-pagetsx-cancel"
							className="w-50 p-2 text-center"
							style={{
								all: 'unset',
								borderRight: '1px solid #c0c5c5',
								color: '#f2675e',
								cursor: 'pointer',
							}}
							onClick={() => {
								// setShowSkipModal(false);
								// window.location.reload();
								documentSkipCancel();
							}}>
							Cancel
						</button>
						<button
							id="btn-pagetsx-ok"
							className="w-50 p-2 text-center"
							style={{ all: 'unset', color: '#3892f3', cursor: 'pointer' }}
							onClick={skipDocuSubmission}>
							OK
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
